import { gql } from "apollo-boost";

export const GET_ANALYTICS = gql`
  query GetAnalytics(
    $aggregateEnd: String!
    $aggregateStart: String!
    $month: String!
  ) {
    analytics(
      aggregateEnd: $aggregateEnd
      aggregateStart: $aggregateStart
      month: $month
    ) {
      aggregates {
        monthlyAverageNewPatients
        monthlyAverageOfficeVisits
        monthlyAveragePatientCollections
        monthlyAverageReactivations
        months {
          id
          newPatients
          officeVisits
          patientCollections
          reactivations
          year
        }
        newPatients
        officeVisits
        patientCollections
        reactivations
        runningNewPatientValue
        runningOfficeVisitAverage
        runningPatientVisitAverage
      }
      month {
        id
        newPatients
        officeVisits
        patientCollections
        reactivations
        year
      }
    }
  }
`;

export interface GetAnalyticsData {
  analytics?: {
    aggregates?: {
      monthlyAverageNewPatients?: number;
      monthlyAverageOfficeVisits?: number;
      monthlyAveragePatientCollections?: number;
      monthlyAverageReactivations?: number;
      months?: Array<{
        id?: string;
        newPatients?: number;
        officeVisits?: number;
        patientCollections?: number;
        reactivations?: number;
        year?: number;
      }>;
      newPatients?: number;
      officeVisits?: number;
      patientCollections?: number;
      reactivations?: number;
      runningNewPatientValue?: number;
      runningOfficeVisitAverage?: number;
      runningPatientVisitAverage?: number;
    };
    month?: {
      id?: string;
      newPatients?: number;
      officeVisits?: number;
      patientCollections?: number;
      reactivations?: number;
      year?: number;
    };
  };
}

export interface GetAnalyticsVariables {
  aggregateEnd: string;
  aggregateStart: string;
  month: string;
}

export const UPDATE_ANALYTICS_MONTH = gql`
  mutation UpdateAnalyticsMonth(
    $data: AnalyticsMonthInput!
    $month: Int!
    $year: Int!
  ) {
    updateAnalyticsMonth(data: $data, month: $month, year: $year) {
      code
      message
    }
  }
`;

export interface UpdateAnalyticsMonthVariablesData {
  newPatients?: number;
  officeVisits?: number;
  patientCollections?: number;
  reactivations?: number;
}

export interface UpdateAnalyticsMonthVariables {
  data: UpdateAnalyticsMonthVariablesData;
  month: number;
  year: number;
}
